// src/features/patientinfo/patentInfoSelectors.ts

import { RootState } from "@core/store"

export const patientListSelector = (state: RootState) =>
  state.patient.patientlist

export const selectedPatientSelector = (state: RootState) =>
  state.patient.selectedPatient

export const selectedInsuranceSelector = (state: RootState) =>
  state.patient.selectedInsurance

export const loadingSelector = (state: RootState) => state.patient.loading

export const errorSelector = (state: RootState) => state.patient.error
